import { FC, useContext, useEffect, useState } from "react";
import Select, { GroupBase, OptionsOrGroups, PropsValue, SingleValue } from "react-select";

import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { AddNoteProps, saveNoteApiResponseType } from "./types";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { AuthContext } from "src/context/authContext";
import { format } from "date-fns";
import RootModal from "../rootModal";
import { NOTE_DROPDOWN } from "src/constants/stats";



const AddNote: FC<AddNoteProps> = ({ isModalVisible, caseId, hideModal, refreshListing}): JSX.Element => {
  const [treatmentDate, changeTreatmentDate] = useState<Date | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isInvalid, setInvalidStatus] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [noteDate, changeNoteDate] = useState<string>("");
  const [notes, setNote] = useState<string>('');
  const [noteError, updateNoteError] = useState<string>("");
  const {isManufacturer}=useContext(AuthContext)
  const { data: saveNoteData, mutate: saveNoteMutate, error: saveNoteError } = useFetch<saveNoteApiResponseType>(APIEndpoints.SAVE_NOTE, {}, {},false)
  const { showToast } = useContext(ToastContext);

  const onChangeSelect = (value: string) => {
    setNote(value);
    if (noteError.length > 0) updateNoteError("")
  };

  const saveNotes = () => {
    if (notes.length > 0) {
      if (noteError.length > 0) updateNoteError("")
      const requestBody = {
        "ref_id": caseId, // case id, wrt case
        "ref_type":isManufacturer ? "MfgrCase" :'Case', // always this
        "description": notes,
        ...(treatmentDate ? {
          "note_date": format(treatmentDate, "yyyy-MM-dd") // year-month-day
        } : {})
      }
      //console.log("Save Notes.......",requestBody)
      saveNoteMutate(requestBody)
    } else {
      updateNoteError("Note is required")
    }
  };

  useEffect(() => {
    if (saveNoteData || saveNoteError) {
      hideModal()
      if(saveNoteData){
        const { code } = saveNoteData;
        if (code === 200) {
          showToast([`Notes Save Successfully`], ToastTypes.SUCCESS);

          refreshListing(saveNoteData.data)
        }
      }
    }

    return(()=>{
      setNote('')
      changeNoteDate('')
      changeTreatmentDate(null)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveNoteData, saveNoteError]);

  return (
    <RootModal isModalVisible={isModalVisible} hideModal={hideModal}>
      <div className="modal-dialog modal-lg p-0 border-0 rounded-3" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title mb-0" id="exampleModalLabel">
              New Note For Case {caseId}
            </h3>
            <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
          </div>

          <div className="modal-body">
            <p className="text-center "> Please specify note and date... </p>

            <div className="row my-2 align-items-center">
              <div className="col-3 text-end">
                <label htmlFor="note_description" className="form-label mb-0">Note *</label>
              </div>
              <div className="col-7">
                <Select
                  options={NOTE_DROPDOWN as unknown as OptionsOrGroups<string, GroupBase<string>>}
                  inputId="note_description"
                  classNames={{
                    control(_props) {
                      return `input-group ${noteError.length > 0 ? "border-danger" : ""}`
                    },
                  }}
                  placeholder="Select a note..."
                  value={NOTE_DROPDOWN.find((note) => note.value === notes) as unknown as PropsValue<string>}
                  onChange={(value: SingleValue<string>) => onChangeSelect((value as unknown as {value:string}).value)}
                />
                {noteError ? <p style={{fontSize:12}} className="text-danger text-start mb-0 mt-1 ms-1">{noteError}</p> : null}
              </div>
            </div>

            <div className="row my-2 align-items-center">
              <div className="col-3 text-end">
                <label htmlFor="noteDate" className="form-label mb-0">Date</label>
              </div>
              <div className="col-7">
                {/* <input
                  type="date"
                  value={noteDate}
                  onChange={(e) => changeNoteDate(e.target.value)}
                  name="noteDate"
                  id="noteDate"
                  className="form-control"
                /> */}
                 <DatePicker
                    selected={treatmentDate}
                    onChange={(date) => changeTreatmentDate(date || null)}
                    dateFormat="MM/dd/yyyy"
                    className={`form-control ${isInvalid ? "is-invalid" : ""}`}
                    placeholderText="mm/dd/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    customInput={
                      <ReactInputMask mask="99/99/9999">
                        {(inputProps: {}) => <input {...inputProps} />}
                      </ReactInputMask>
                    }
                    //maxDate={bentype === "med" ? new Date() : undefined}
                    wrapperClassName="w-100"
                    // portalId="root"
                    // popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
                />
                {isInvalid && (
                  <p className="mb-0 text-danger pt-1">Date is required</p>
                )}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              onClick={saveNotes}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </RootModal>
  );
};

export default AddNote;
